import type { BaseUsecase } from '@usecases/base-usecase';
import type { PhoneCall } from '@salesforce/scv-connector-base';

export interface SupervisorListenEventPublisher {
  publish(call: PhoneCall, callId: string, agentNumber: string): Promise<void>;
}

export interface SupervisorListenRequest {
  call: PhoneCall;
  callId: string;
  agentNumber: string;
}

export interface SupervisorListenUsecase
  extends BaseUsecase<SupervisorListenRequest, void> {
  run(request: SupervisorListenRequest): Promise<void>;
}

export class SupervisorListen implements SupervisorListenUsecase {
  constructor(private publisher: SupervisorListenEventPublisher) {}

  async run(request: SupervisorListenRequest): Promise<void> {
    await Promise.all([
      this.publisher.publish(
        request.call as PhoneCall,
        request.callId,
        request.agentNumber,
      ),
    ]);
  }
}
